/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Autosave_ErrorInputs */

const cs_autosave_error = /** @type {(inputs: Autosave_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uložení selhalo`)
};

const en_autosave_error = /** @type {(inputs: Autosave_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save failed`)
};

/**
* | output |
* | --- |
* | "Save failed" |
*
* @param {Autosave_ErrorInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const autosave_error = /** @type {((inputs?: Autosave_ErrorInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Autosave_ErrorInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_autosave_error(inputs)
	return cs_autosave_error(inputs)
});